let currentOrderId;

const manageOrder = (id) => {
    currentOrderId = id;
    openForm(id, 'manage-order')
}

const orderBoxing = () => {
    const stateRef = database.ref('/orders/' + currentOrderId + '/state/')
    stateRef.set('confezionamento')
}

const orderShipped = () => {
    openShippingModal();
}

const setShipped = () => {
    const stateRef = database.ref('/orders/' + currentOrderId + '/state/')
    stateRef.set('spedito').then(() => {
        const trackingRef = database.ref('/orders/' + currentOrderId + '/shippingState/trackingNumber')
        trackingRef.set($('#tracking-number').val()).then(() => {
            closeModal()
        })
    })
}

const openShippingModal = () => {
    $('.pent-modal').addClass('open');
    let modalContent = `
        <div class="modal-content admin-form">
            <img
                class="modal-close-button"
                src="/assets/images/ui/close-button.png"
                onClick="closeModal()"
                >
            <h4 class="modal-title">Tracking Number</h4>
            <div class="spacer" style="height: 70px"></div>
            <div class="modal-content-in pl-2 pr-2">
                <div class="form-group">
                    <label for="pent-size pb-2">tracking number</label>
                    <input type="text" id="tracking-number" class="form-control">
                    </input>
                </div>
            </div>
            <div onClick="setShipped()" class="pl-2 pr-2 pb-2">
                <button class="w-100 small formal bg-green text-white"><small>Spedito</small></button>
            </div>
        </div>
    `
    $('.pent-modal').append(modalContent);
}
